/**
 * `document_access` — journal des consultations du coffre (base galerie, 4.1).
 *
 * Conservé douze mois.
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
/**
 * Les gestes que le journal retient.
 *
 * `archive` s'ajoute aux quatre de 3.5 parce que 4.2 interdit l'effacement
 * dans une galerie active : ce qu'une galerie fait d'un document dont elle ne
 * veut plus, c'est l'archiver. Sans cette valeur, le geste le plus proche
 * d'une suppression serait le seul à ne pas laisser de trace — ou devrait
 * mentir en se journalisant « supprimé ». `supprime` reste : c'est la
 * suppression réelle du RGPD (7.7), qui ne passe que par le carnet.
 */
export const ACTIONS_DOCUMENT = ['ouvert', 'telecharge', 'modifie', 'archive', 'supprime'];
export const actionDocumentSchema = z.enum(ACTIONS_DOCUMENT);
export const documentAccessSchema = withAudit(z.object({
    _id: idSchema,
    documentId: idSchema,
    compteId: idSchema,
    action: actionDocumentSchema,
    date: z.date(),
    adresse: z.string().optional(),
}));
export const documentAccessCreationSchema = documentAccessSchema.omit(CHAMPS_DOCUMENT);
//# sourceMappingURL=document-access.js.map